export default __webpack_public_path__ + "static/media/win.851d41c7.mp3";